import React, { Component } from 'react';

export class ModalButton extends Component {
     render() {
          return <button onClick={() => this.props.handleClick()}>{ this.props.buttonName }</button>
     }
}
